import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#4f9cff', // bright accent blue
    },
    secondary: {
      main: '#00c896', // teal green accent
    },
    background: {
      default: '#0f172a', // deep navy background
      paper: '#1e293b',   // card/sidebar background
    },
    text: {
      primary: '#e2e8f0',   // light gray text
      secondary: '#94a3b8', // muted gray text
    },
    error: {
      main: '#f87171', // red
    },
    success: {
      main: '#4ade80', // green
    },
    warning: {
      main: '#fbbf24', // amber
    },
    info: {
      main: '#38bdf8', // light blue
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h6: { fontWeight: 600 },
    body1: { color: '#e2e8f0' },
    body2: { color: '#94a3b8' },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundImage: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0px 4px 20px rgba(0,0,0,0.3)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          textTransform: 'none',
          fontWeight: 600,
          padding: '8px 16px',
        },
        containedPrimary: {
          backgroundColor: '#4f9cff',
          '&:hover': {
            backgroundColor: '#3b82f6',
          },
        },
        outlinedPrimary: {
          borderColor: '#4f9cff',
          color: '#4f9cff',
          '&:hover': {
            borderColor: '#3b82f6',
            color: '#3b82f6',
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '4px 8px',
          color: '#94a3b8',
          '&.Mui-selected': {
            backgroundColor: '#1e40af', // highlight for active sidebar item
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#1e3a8a',
            },
          },
          '&:hover': {
            backgroundColor: '#1e293b',
            color: '#e2e8f0',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1e293b', // sidebar background
          color: '#e2e8f0',
        },
      },
    },
  },
});

export default theme;
